import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment.development';

export interface BlockUserResponse {
  ok: boolean;
  msg: string;
}

export interface BlockedUser {
  id_bloqueo: number;
  id_usuario_bloqueador: number;
  id_usuario_bloqueado: number;
  fecha_bloqueo: string;
  motivo?: string | null;
  activo: boolean;
  bloqueado: {
    id_usuario: number;
    nombre: string;
    apellido: string | null;
    nombre_usuario: string;
    foto_perfil?: string;
  };
}

export interface GetBlockedUsersResponse {
  ok: boolean;
  bloqueados: BlockedUser[];
  total: number;
}

@Injectable({
  providedIn: 'root'
})
export class BlockingService {
  private apiUrl = `${environment.apiUrl}/bloqueos`;

  constructor(private http: HttpClient) {}

  blockUser(idUsuario: number, motivo?: string): Observable<BlockUserResponse> {
    return this.http.post<BlockUserResponse>(`${this.apiUrl}/${idUsuario}`, { motivo }).pipe(
      catchError(error => {
        console.error('Error al bloquear usuario:', error);
        return of({ ok: false, msg: error.error?.msg || 'Error al bloquear usuario' });
      })
    );
  }

  unblockUser(idUsuario: number): Observable<BlockUserResponse> {
    return this.http.delete<BlockUserResponse>(`${this.apiUrl}/${idUsuario}`).pipe(
      catchError(error => {
        console.error('Error al desbloquear usuario:', error);
        return of({ ok: false, msg: error.error?.msg || 'Error al desbloquear usuario' });
      })
    );
  }

  getBlockedUsers(): Observable<GetBlockedUsersResponse> {
    return this.http.get<GetBlockedUsersResponse>(`${this.apiUrl}`).pipe(
      catchError(error => {
        console.error('Error al obtener lista de bloqueados:', error);
        return of({ ok: false, bloqueados: [], total: 0 });
      })
    );
  }
}

